import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form } from 'react-bootstrap';

/**
 * Oswiadczenie zdrowotne (BRC, WK 2026-10-01) — jedna karta dla stanowiska bramki, telefonu z
 * zaproszenia i kiosku. Tresc pochodzi z API (ustawienie instancji, nie z tlumaczen). OK jest
 * nieaktywne, dopoki osoba nie zaznaczy potwierdzenia; „Anuluj" nie zapisuje niczego.
 */
const HealthStatementCard = ({ personName = null, text, onConfirm, onCancel, busy = false, error = null }) => {
  const { t } = useTranslation();
  const [checked, setChecked] = useState(false);

  return (
    <div data-testid="health-statement-card" className="text-start">
      <h5 className="text-center mb-3">{t('health_statement_title')}</h5>
      {personName && (
        <p className="text-center fw-bold mb-2" data-testid="health-statement-person">{personName}</p>
      )}
      <p data-testid="health-statement-text" style={{ whiteSpace: 'pre-line' }}>{text}</p>
      <Form.Check
        type="checkbox"
        id="health-statement-checkbox"
        className="mb-3"
        label={t('health_statement_confirm')}
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
        disabled={busy}
      />
      {error && (
        <div className="alert alert-warning" data-testid="health-statement-error">{error}</div>
      )}
      <div className="d-grid gap-2">
        <Button
          variant="danger"
          disabled={!checked || busy}
          onClick={onConfirm}
          data-track-id="health-statement-ok"
        >
          {t('ok')}
        </Button>
        <Button variant="secondary" disabled={busy} onClick={onCancel} data-track-id="health-statement-cancel">
          {t('health_statement_cancel')}
        </Button>
      </div>
    </div>
  );
};

export default HealthStatementCard;
